import type { FaireProductEntity } from "../../entity_types/product";

export const viverano_18: FaireProductEntity = {
  token: "viverano-18",
  type: "product",
  name: "Train Applique Sweater Knit Baby Jumpsuit (Organic Cotton)",
  brandName: "Viverano Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/818606e5c77efe254d45f107c30b687f0eb1890715dc756aedb3c1be7f210705.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=720&precrop=2051,2051,x231,y221,safe&width=720",
  priceDollars: 26,
  msrpDollars: 44,
  freeShipping: false,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_apparel-baby"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
